module.exports = __webpack_public_path__ + "static/media/menu.4d72275f.png";